/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  // 2026-09-01 heuristic review C9/C14. Judge.me renders review bodies client-side; some imported
  // bodies carry backslash escapes ("chain set\!"). Scrubbed here until the source export is cleaned.
  // C14: one line above the review list saying where the reviews come from.
  var gbacNoteText = 'These reviews come from Grace Blooms customers across our family of stores. Same chains, same makers.';
  function gbacScrub(root) {
    var nodes = (root || document).querySelectorAll('.jm-review-content, .jm-review-title, .jdgm-rev__body, .jdgm-rev__title');
    for (var i = 0; i < nodes.length; i++) {
      var walker = document.createTreeWalker(nodes[i], NodeFilter.SHOW_TEXT);
      var t;
      while ((t = walker.nextNode())) {
        if (t.nodeValue.indexOf('\\') !== -1) t.nodeValue = t.nodeValue.replace(/\\([!.,'"?()\-:;])/g, '$1');
      }
    }
  }
  function gbacNote() {
    if (document.querySelector('.gbac-reviews-note')) return;
    var first = document.querySelector('.jm-review-content, .jdgm-rev__body');
    if (!first) return;
    var root = first;
    while (root.parentElement && /(^|\s)(jm-|jdgm-)/.test(root.parentElement.className || '')) root = root.parentElement;
    var p = document.createElement('p');
    p.className = 'gbac-reviews-note';
    p.textContent = gbacNoteText;
    root.parentElement.insertBefore(p, root);
  }
  function gbacReviewsPass() { gbacScrub(); gbacNote(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', gbacReviewsPass); else gbacReviewsPass();
  var gbacObs = new MutationObserver(function () {
    if (gbacObs._t) return;
    gbacObs._t = setTimeout(function () { gbacObs._t = null; gbacReviewsPass(); }, 250);
  });
  gbacObs.observe(document.documentElement, { childList: true, subtree: true });


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
